<section class="bg-grey-100 px-24 pb-12 pt-16 md:hidden">
    <h1 class="text-31 leading-36">{{ content().heroHeadline }}</h1>
    <h2 class="text-16 leading-27">{{ locationHeadline() }}</h2>
</section>
<ui-m030-c020-teaser-allrounder
    [strongText]="content().heroSubHeadline ?? ''"
    [image]="content().heroImage?.url ?? ''"
    [isFirstView]="true"
    [imageAlt]="content().heroImage?.alt || content().heroHeadline"
>
    <h1 class="hidden md:block" headline>{{ content().heroHeadline }}</h1>
    <h2 class="mb-24 hidden md:block" subheadline>{{ locationHeadline() }}</h2>

    <p text>{{ content().heroCopy }}</p>

    <a class="button-primary lg:w-max" hyundaiRouterLink="." fragment="kontakt" cta>Kontaktieren Sie uns</a>
</ui-m030-c020-teaser-allrounder>

<section>
    <ui-m030-c130-warrenty-list [warrantyList]="content().warrantyList">
        <h3 headline>{{ content().warrantyHeadline }}</h3>
    </ui-m030-c130-warrenty-list>
</section>

@defer {
    <app-global-contact id="kontakt" isFirstView="false" />
    @if (content().legalLines; as legalLines) {
        <section class="inner-page-wrapper py-24 text-14 leading-20 text-grey-400">
            <p class="empty:*:h-24" [innerHTML]="legalLines.html"></p>
        </section>
    }
}
